import {
  AverageAssessmentAnswersByProgramFragment,
  GetCareerRoleRelatedDataQueryQuery,
} from "types/graphql-schema";

import { assertEdgesNonNull } from "@helpers/helpers";

export const mapCareerDevelopmentGoalsWithCompetencyIds = (
  data?: GetCareerRoleRelatedDataQueryQuery,
) => {
  return (
    data?.careerRole?.developmentGoals
      ? assertEdgesNonNull(data.careerRole.developmentGoals)
      : []
  ).map((goal) => ({
    ...goal,
    competencyIds: assertEdgesNonNull(goal.competencyRelations).map(
      (c) => c.competencyId,
    ),
  }));
};

export const mapCompetencyAverageAssessmentAnswersById = (
  data?: GetCareerRoleRelatedDataQueryQuery,
) => {
  const competencies = data?.careerRole?.competencies
    ? assertEdgesNonNull(data?.careerRole?.competencies)
    : [];
  return competencies.reduce(
    (memo, competency) => {
      const averageAssessmentAnswersByProgram =
        competency.averageAssessmentAnswersByProgram.filter((item) => !!item);
      if (competency.id && averageAssessmentAnswersByProgram.length > 0) {
        memo[competency.id] = averageAssessmentAnswersByProgram;
      }
      return memo;
    },
    {} as Record<number, AverageAssessmentAnswersByProgramFragment[]>,
  );
};
